<template>
  <img ref="pageImg" :src="imgSrc" :alt="`Side ${page.pageNumber}`" @load="loaded" :style="imgStyle" />
</template>

<script>
import { assetApi } from 'api'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      imgSrc: ''
    }
  },
  mounted () {
    this.populateUrl()
  },
  created () {
  },
  methods: {
    loaded () {
      this.$emit('loaded', this.$refs.pageImg)
    },
    populateUrl () {
      this.imgSrc = assetApi.getPreviewUrl(this.page.assetUrlPath, 'full')
    }
  },
  computed: {
    imgStyle () {
      if (this.zoom) {
        return {
          height: `${this.height}px`,
          width: `${this.width}px`
        }
      } else {
        return {
          width: '100%'
        }
      }
    },
    ...mapGetters(['zoom'])
  },
  watch: {
    page () {
      this.populateUrl()
    }
  },
  props: [
    'page',
    'height',
    'width'
  ]
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/page/PageImage.vue